<script>

  import { onMount, onDestroy } from 'svelte';
  import { submitting } from './stateStore.js'
  const StripeAPI = Stripe("pk_live_wRNwElie7vyOKITika98Jfzo");

  let blockUI = false;


  //function with signature (token, e);
  export let onComplete, label, locale, errorMessage, submitText;


  //init stripe elems on mount
  let card;

  onMount( () => {
    const elements = StripeAPI.elements({ locale });

    card = elements.create('card', {
      classes: {
        base: 'input outline'
      },
      hidePostalCode: true
    });
    card.mount('#add_card_number');
  });


  function submitDonation(e) {
    e.preventDefault();

    //prevent double click
    if ( !!$submitting ) {
      return;
    }

    //set temporary state
    e.target.innerHTML = 'Please wait / Attendez svp';
    $submitting = true;

    StripeAPI.createToken(card)
      .then( ({ token, error }) => {

        if ( !!error ) {
          $submitting = false;
          console.log('error', error);
          errorMessage = error.message;
          e.target.innerHTML = 'Submit';

          return;
        }

        onComplete( token.id );

      })
      .catch(e => {
        console.log('e', e);
      })


  }
</script>
<div class='row mb-4'>
    <div class={'col-12'}>
      <label for='add_card'>{label}</label>
      <div id="add_card_number" name="add_card" class="input field empty"></div>
      {#if errorMessage}
        <small class='red'>{errorMessage}</small>
      {/if}
    </div>


</div>
<div class='row' style='padding-bottom: 1rem;'>
  <div class="col-12 col-md-6">
  </div>
  <div class='col-12 col-md-6 text-right d-flex align-items-center justify-content-end'>
    {#if $submitting }
      <span>Please wait / Patientez</span>
      <div class='loading'></div>

      {:else}
      <a href={'#'} on:click={submitDonation} class={'next ' + ( $submitting && 'disabled' || '' ) } >{submitText}</a>
    {/if}
  </div>
</div>

<style>
.loading {
  margin-left: 20px;
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #333; /* Blue */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
  }

  @keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
